import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const onlineApplicationList = createAsyncThunk(
  'online-application/list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}online-application/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const onlineApplicationArchivedList = createAsyncThunk(
  'online-application/archived-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}online-application/archived-list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getCampusUnitFaculties = createAsyncThunk(
  'application-form/get-campus-unit-faculties',
  async (param: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}application-form/get-campus-unit-faculties`, {
        params: param,
      })
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getCampusUnits = createAsyncThunk(
  'application-form/get-campus_units',
  async (lang: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}application-form/get-campus_units/${lang}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const onlineApplicationStore = createAsyncThunk(
  'application-form/store',
  async (campusClassData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}application-form/store`, campusClassData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const onlineApplicationArchive = createAsyncThunk(
  'online-application/archive',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}online-application/archive/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const onlineApplicationDelete = createAsyncThunk(
  'online-application/delete',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}online-application/delete/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const onlineApplicationExcelReport = createAsyncThunk(
  'online-application/online-application-excel',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${api}online-application/online-application-excel`, {
        responseType: 'blob',
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Online Application Report.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

type SchoolState = {
  errors: any
}

const initialState: SchoolState = {
  errors: '',
}

export const onlineApplicationSlice = createSlice({
  name: 'online-application',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(onlineApplicationStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = onlineApplicationSlice.actions
export default onlineApplicationSlice.reducer
